import { render } from "./UpgraderItemElement.vue?vue&type=template&id=4951dfcf&scoped=true"
import script from "./UpgraderItemElement.vue?vue&type=script&lang=js"
export * from "./UpgraderItemElement.vue?vue&type=script&lang=js"

import "./UpgraderItemElement.vue?vue&type=style&index=0&id=4951dfcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4951dfcf"]])

export default __exports__